import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';
import { AccordionPanel, Select } from 'reaxl';
import { formatNumber } from '@atc/string-fns';
import FilterTitle from '../FilterTitle';

/**
 *  Describe the component
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function FilterSelect(_ref) {
  let {
    collapsed,
    collapsedTitle,
    filter = {},
    filters = {},
    filtersOrder,
    hideOptionCounts = false,
    onOptionChange = () => {},
    onOptionsClear,
    resultCount,
    values = {},
    ...rest
  } = _ref;
  // remove unused props
  delete rest.component;
  const value = _get(values, [filter.name], '');
  const title = /*#__PURE__*/_jsx(FilterTitle, {
    title: filter.label
  }, "filterTitleKey");
  const getFilterOptions = options => {
    if (hideOptionCounts) {
      return options;
    }
    return options && options.map(option => ({
      ...option,
      label: option.count || option.count === 0 ? `${option.label} (${formatNumber({
        value: option.count
      })})` : option.label
    }));
  };
  return /*#__PURE__*/_jsx(AccordionPanel, {
    "data-cmp": "filterSelect",
    eventKey: filter.name,
    title: title,
    ...rest,
    children: /*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-xs-12",
        children: /*#__PURE__*/_jsx(Select, {
          onChange: event => onOptionChange(event, filter),
          options: getFilterOptions(filter.options),
          name: filter.name,
          value: value
        })
      })
    })
  });
}
export default FilterSelect;